/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  TextInput,
  FormGroup,
  FormLabel,
  DropdownSkeleton,
  ComboBox,
  MultiSelect,
} from 'carbon-components-react';
import Add16 from '@carbon/icons-react/lib/add/16';
import AuditRepository from '../../../helpers/api/AuditRepository';
import { apioperation, entitiesLabels, getError } from '../../../helpers/Constants';
import { api } from '../../../helpers/api/api';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import Close16 from '@carbon/icons-react/lib/close/16';

export default class AuditSubcontractor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubContractor: null,
      selectedPurchaseOrder: null,
      purchaseOrder: null,
      auditSubcontractors: this.props.auditSubcontractors,
      subcontractors: [],
      purchaseOrders: [], //RITM0646764
      refreshSubContractor: 0, //RITM0646764
      refreshPurchaseOrder: 0, //RITM0646764
      isVisibleModal: false, //RITM0646764
    };
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const subcontractors = await this.getItems();
    this.setState({ subcontractors, loading: false });
  }

  addSubcontractors = () => { 
    if(this.state.selectedPurchaseOrder !== null){
      let isExsist = false;
      for (let i = 0; i < this.state.selectedPurchaseOrder.length; i++) {
        let auditSubContractor = this.state.auditSubcontractors?.find(x => x.name === this.state.selectedSubContractor.name && x.purchaseOrder === this.state.selectedPurchaseOrder[i].name);
        if(auditSubContractor !== undefined && auditSubContractor !== null){
          isExsist = true;
        }
      }

      if(isExsist){
        showNotification.error('SubContractor - Purchase Order already entered');
        return false;
      }
    }
    
    this.setState((prevState) => {
      const { auditSubcontractors } = prevState;
      prevState.selectedPurchaseOrder.forEach(item => {
        let newItem = {
          id: prevState.selectedSubContractor.id,
          name: prevState.selectedSubContractor.name,
          purchaseOrder: item.name,
          idPurchaseOrder: item.id
        };
        auditSubcontractors.push(newItem);
      });
      
      let { subcontractors } = prevState;
      let { selectedSubContractor } = prevState;
      let { purchaseOrders } = prevState;
      let { selectedPurchaseOrder } = prevState;
      let { purchaseOrder } = prevState;
      let { refreshSubContractor } = prevState;
      let { refreshPurchaseOrder } = prevState;

      const itemsId = auditSubcontractors.map((filter) => filter.idPurchaseOrder);

      selectedSubContractor = null;
      selectedPurchaseOrder = null;
      purchaseOrders = purchaseOrders?.filter((item) => !itemsId.includes(item.id));
      purchaseOrder = null;
      refreshSubContractor++;
      refreshPurchaseOrder++;

      return { auditSubcontractors, subcontractors, selectedSubContractor, purchaseOrders, selectedPurchaseOrder, purchaseOrder, refreshSubContractor, refreshPurchaseOrder };
    }, () => this.props.onChange(this.state.auditSubcontractors));
  };

  addManualSubcontractors = () => {    
    let isSAPExsist = this.state.purchaseOrders?.find(x => x.name === this.state.purchaseOrder);
    if(isSAPExsist !== undefined && isSAPExsist !== null){
      showNotification.error('Purchase Order already exists in SAP');
      return false;
    }
 
    let isExsist = this.state.auditSubcontractors?.find(x => x.name === this.state.selectedSubContractor?.name && x.purchaseOrder === this.state.purchaseOrder)
    if(isExsist !== undefined && isExsist !== null){
      showNotification.error('SubContractor - Purchase Order already entered');
      return false;
    }

    this.setState((prevState) => {
      const newItem = {
        id: prevState.selectedSubContractor.id,
        name: prevState.selectedSubContractor.name,
        purchaseOrder: prevState.purchaseOrder,
        idPurchaseOrder: null,
      };

      const { auditSubcontractors } = prevState;
      auditSubcontractors.push(newItem);
      let { subcontractors } = prevState;
      let { selectedSubContractor } = prevState;
      let { purchaseOrders } = prevState;
      let { selectedPurchaseOrder } = prevState;
      let { purchaseOrder } = prevState;
      let { refreshSubContractor } = prevState;
      let { refreshPurchaseOrder } = prevState;

      selectedSubContractor = null;
      selectedPurchaseOrder = null;
      purchaseOrder = null;
      refreshSubContractor++;
      refreshPurchaseOrder++;

      return { auditSubcontractors, subcontractors, selectedSubContractor, purchaseOrders, selectedPurchaseOrder, purchaseOrder, refreshSubContractor, refreshPurchaseOrder };
    }, () => {
      this.props.onChange(this.state.auditSubcontractors);
      this.handleOnCloseModal();
    });
  };

  getItems = async () => {
    let filtered = [];
    try {
      const items = await this.repository.getSubcontractors();
      filtered = items;
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return filtered.sort((a, b) => a.name.localeCompare(b.name));
  };

  getPurchaseOrders = (idSubcontractor) => {
    let filtered = [];
    
    if(idSubcontractor === null){
      this.setState({
        purchaseOrders: filtered,
      });
      return;
    }    

    api.getAll('/audit/getpurchaseorders/' + idSubcontractor)
      .then((response) => {
        const { data } = response;
        const itemsId = this.state.auditSubcontractors.map((filter) => filter.idPurchaseOrder);
        filtered = data.filter((item) => !itemsId.includes(item.id));
        this.setState({
          purchaseOrders: filtered.sort((a, b) => a.name.localeCompare(b.name)),
        });        
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PURCHASEORDERS, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  handleOnChangeSubContractor = (event) => {
    this.setState((prevState) => {      
      const curState = prevState;
      curState.selectedSubContractor = event.selectedItem || null;
      curState.refreshPurchaseOrder++;      
      return { curState };
    }, () => { this.getPurchaseOrders(event?.selectedItem?.id || null); })
  }

  handleOnChangePurchaseOrder = (event, type) => {
    if(type === 'txt'){
      const val = event.target.value;
      this.setState((prevState) => {
        const curState = prevState;
        curState.purchaseOrder = val || null;
        return { curState };
      });
    }

    if(type === 'cmb'){
      this.setState((prevState) => {      
        const curState = prevState;
        curState.selectedPurchaseOrder = event.selectedItems || null;
        return { curState };
      })
    }
  }

  handleDelete = (item) => {
    this.setState((prevState) => {
      const { auditSubcontractors } = prevState;
      const index = auditSubcontractors.findIndex((el) => el.id === item.id && el.idPurchaseOrder === item.idPurchaseOrder && el.name === item.name && el.purchaseOrder === item.purchaseOrder);
      auditSubcontractors.splice(index, 1);
      
      const { subcontractors } = prevState;
      let { selectedSubContractor } = prevState;
      let { purchaseOrders } = prevState;
      let { selectedPurchaseOrder } = prevState;
      let { purchaseOrder } = prevState;
      let { refreshSubContractor } = prevState;
      let { refreshPurchaseOrder } = prevState;

      subcontractors.sort((a, b) => a.name.localeCompare(b.name));
      selectedSubContractor = null;
      selectedPurchaseOrder = null;
      purchaseOrders = [];
      purchaseOrder = null;
      refreshSubContractor++;
      refreshPurchaseOrder++;

      return { auditSubcontractors, subcontractors, selectedSubContractor, purchaseOrders, selectedPurchaseOrder, purchaseOrder, refreshSubContractor, refreshPurchaseOrder };
    },() => this.props.onChange(this.state.auditSubcontractors));
  };

  handleOnCloseModal = () => {
    this.setState((prevState) => {
      let { subcontractors } = prevState;
      let { selectedSubContractor } = prevState;
      let { purchaseOrders } = prevState;
      let { selectedPurchaseOrder } = prevState;
      let { purchaseOrder } = prevState;
      let { refreshSubContractor } = prevState;
      let { refreshPurchaseOrder } = prevState;
      let { isVisibleModal } = prevState;

      selectedSubContractor = null;
      selectedPurchaseOrder = null;
      purchaseOrders = [];
      purchaseOrder = null;
      refreshSubContractor++;
      refreshPurchaseOrder++;
      isVisibleModal = false;

      return { subcontractors, selectedSubContractor, purchaseOrders, selectedPurchaseOrder, purchaseOrder, refreshSubContractor, refreshPurchaseOrder, isVisibleModal };
    });
  }

  handleOnOpenModal = () => {
    this.setState((prevState) => {
      let { subcontractors } = prevState;
      let { selectedSubContractor } = prevState;
      let { purchaseOrders } = prevState;
      let { selectedPurchaseOrder } = prevState;
      let { purchaseOrder } = prevState;
      let { refreshSubContractor } = prevState;
      let { refreshPurchaseOrder } = prevState;
      let { isVisibleModal } = prevState;

      selectedSubContractor = null;
      selectedPurchaseOrder = null;
      purchaseOrders = [];
      purchaseOrder = null;
      refreshSubContractor++;
      refreshPurchaseOrder++;
      isVisibleModal = true;

      return { subcontractors, selectedSubContractor, purchaseOrders, selectedPurchaseOrder, purchaseOrder, refreshSubContractor, refreshPurchaseOrder, isVisibleModal };
    });
  }

  renderManualInputModal = () => 
    this.state.isVisibleModal && (
        <div className="bx--modal bx--modal-tall is-visible">
            <div className="bx--modal-container" style={{minHeight: '55%'}}>
                <div className="bx--modal-header">
                    <h3 className="bx--modal-header__heading">New Purchase Order</h3>
                    <Button
                        className="bx--modal-close"
                        renderIcon={Close16}
                        onClick={this.handleOnCloseModal}
                    />
                </div>

                <div className="bx--modal-content">
                    <div className="bx--row bx--modal-content-detail">
                        <div className="bx--col-lg-6 bx--col-md-4">
                          <FormGroup>
                            <FormLabel>Subcontractor/Supplier *</FormLabel>
                            <ComboBox
                              onChange={(event) => this.handleOnChangeSubContractor(event)}
                              id="cmbSubcontractor"
                              disabled={this.props.disabled}
                              items={this.state.subcontractors}
                              key={this.state.refreshSubContractor}
                              itemToString={(item) => (item ? item && item.name : "")}
                              placeholder="Select a Subcontractor/Supplier"
                              invalid={this.props.invalid}
                              invalidText={this.props.invalidText}
                            />
                          </FormGroup>
                        </div>
                        <div className="bx--col-lg-6 bx--col-md-4">
                          <FormGroup>
                            <FormLabel>Purchase Order *</FormLabel>
                            <TextInput
                              id="txtPurchaseOrder"
                              name="txtPurchaseOrder"
                              onChange={(event) => this.handleOnChangePurchaseOrder(event, 'txt')}
                              key={this.state.refreshPurchaseOrder}
                              disabled={this.props.disabled || this.state.selectedSubContractor == null}
                              invalid={this.props.invalid}
                              invalidText={this.props.invalidText}
                            />
                          </FormGroup>
                        </div>
                    </div>
                </div>
                <div className="bx--modal-footer">
                    <Button
                        className="button--max-width"
                        kind="secondary"
                        onClick={this.handleOnCloseModal}
                    >
                        Cancel
                    </Button>
                    <Button className="button--max-width" kind="primary" onClick={this.addManualSubcontractors}>
                        Add
                    </Button>
                </div>
            </div>
        </div>
    );
  

  render() {
    return this.state.loading ? (
      <div className="bx--row">
        <div className="bx--col-lg-12 bx--col-md-12">
          <DropdownSkeleton />
        </div>
      </div>
    ) : (
      <div>
        <div className="bx--row">
          {this.renderManualInputModal()}
          <div className="bx--col-lg-5 bx--col-md-8">
            <FormGroup>
              <FormLabel>Subcontractor/Supplier *</FormLabel>
              <ComboBox
                onChange={(event) => this.handleOnChangeSubContractor(event)}
                id="cmbSubcontractor"
                disabled={this.props.disabled}
                items={this.state.subcontractors}
                key={this.state.refreshSubContractor}
                itemToString={(item) => (item ? item && item.name : "")}
                placeholder="Select a Subcontractor/Supplier"
                invalid={this.props.invalid}
                invalidText={this.props.invalidText}
              />
            </FormGroup>
          </div>
          <div className="bx--col-lg-4 bx--col-md-8">
            <FormGroup>
              <FormLabel>Purchase Order *</FormLabel>
              <MultiSelect.Filterable
                id="cmbPurchaseOrder"
                disabled={this.props.disabled || this.state.purchaseOrders?.length === 0}
                placeholder={
                  this.state.selectedPurchaseOrder < 1
                    ? 'Choose one or more Purchase Order'
                    : this.state.selectedPurchaseOrder.map((elem) => elem.name).join(', ')
                }
                itemToString={(item) => (item ? item && item.name : '')}
                items={this.state.purchaseOrders}
                key={this.state.refreshPurchaseOrder}
                light={false}
                onChange={(event) => this.handleOnChangePurchaseOrder(event, 'cmb')}
                type="default"
                invalid={this.props.invalid}
                invalidText={this.props.invalidText}
              />
            </FormGroup>
          </div>
          <div className="bx--col-lg-3 bx--col-md-8 addBtnPosition" style={{display: 'flex'}}>
            <Button
              onClick={this.addSubcontractors}
              className="addBtnStyle"
              renderIcon={Add16}
              disabled={
                this.props.disabled ||
                this.state.selectedSubContractor == null ||
                this.state.selectedPurchaseOrder == null
              }
            />
            <Button
              kind="primary"
              style={{marginLeft: '1rem'}}
              onClick={this.handleOnOpenModal}
            >
              Manual input
            </Button>
          </div>
        </div>

        <div className="weekSelector bx--row">
          {this.state.auditSubcontractors.map((item) => (
            <div className="tag-item">
              {`${item.name} - ${item.purchaseOrder}`}
              {this.props.disabled ? null : (
                <button
                  type="button"
                  className="button"
                  onClick={() => this.handleDelete(item)}
                >
                  &times;
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
AuditSubcontractor.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  auditSubcontractors: PropTypes.array,
  onError: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
AuditSubcontractor.defaultProps = {
  invalid: false,
  invalidText: '',
  auditSubcontractors: [],
  disabled: true,
};
